import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { DeliverablesSection } from '../components/DeliverablesSection';
import { AudienceSection } from '../components/AudienceSection';
import { ProcessSection } from '../components/ProcessSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { BonusIntroSection } from '../components/BonusIntroSection';
import { BonusCardsSection } from '../components/BonusCardsSection';
import { ValueStackSection } from '../components/ValueStackSection';
import { BonusClosingSection } from '../components/BonusClosingSection';
import { OfferSection } from '../components/OfferSection';
import { FooterSection } from '../components/FooterSection';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
const META_PIXEL_ID = '1248476953463026';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel(META_PIXEL_ID);
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-gray-300 selection:bg-amber-500/30 selection:text-amber-200 overflow-hidden" data-id="element-254">
      <main data-id="element-255">
        <HeroSection data-id="element-256" />
        <ProblemSection data-id="element-257" />
        <FailedSolutions data-id="element-258" />
        <MechanismSection data-id="element-259" />
        <DeliverablesSection data-id="element-260" />
        <AudienceSection data-id="element-261" />
        <ProcessSection data-id="element-262" />
        <ProofSection data-id="element-263" />
        <FAQSection data-id="element-264" />
        <BonusIntroSection data-id="element-265" />
        <BonusCardsSection data-id="element-266" />
        <ValueStackSection data-id="element-267" />
        <BonusClosingSection data-id="element-268" />
        <OfferSection data-id="element-269" />
      </main>
      <FooterSection data-id="element-270" />
    </div>;
}